"use strict";

function tools_tfxpnwhebwvtppxfcqnvtfazbndvhhnf()
{
	const tools =
	{
		tools:
		{
			tools: "tools"
			,version:1000
			,variant:
				{name: "afc"
				,guid: "tfxpnwhebwvtppxfcqnvtfazbndvhhnf"
			}
			,name:"tools"
			,guid:"tb2b4ca6f01544d2f9a67c8434c41114"
			,magic:"TOOL"
			,FCC:"T00L"
			,meta:{}
		}
		,numbers:
		{
			set_bit( number = 0 , i1position = 1 ,nocheck=false)
			{
				return number |= (1 << (i1position - 1))
			},
			unset_bit( number = 0, i1position = 1 ,nocheck=false)
			{
				return number &= ~(1 << (i1position - 1))
			},
			toggle_bit( number = 0, i1position = 1 ,nocheck=false)
			{
				return number ^= (1 << (i1position - 1))
			},
			set_bits( number = 0, i1position = 1 , length = 1 , value = 1 )
			{
				if( Number.isSafeInteger(number) === false ) { return number; }
				if( Number.isSafeInteger(value ) === false ) { return number; }
				if( number >  (1<<30) )                      { return number; }
				if( number < -(1<<30) )                      { return number; }
				if( value  >  (1<<30) )                      { return number; }
				if( value  <       0  )                      { return number; }
				if( (i1position + length) > 31 )             { return number; }
				if( i1position <  1 )                        { return number; }
				if( i1position > 30 )                        { return number; }
				if( length     <  1 )                        { return number; }
				if( length     > 30 )                        { return number; }

				value |= (1 << 30)

				const bits = value.toString(2).substring(31 - length)
				if( bits.length <= length )
				{
					var i1b = i1position + bits.length
					for( const b of bits )
					{
						if( b == '1' )
						{
							number = tools_tfxpnwhebwvtppxfcqnvtfazbndvhhnf.number.set_bit( number , i1b-- )
						}
						else
						{
							number = tools_tfxpnwhebwvtppxfcqnvtfazbndvhhnf.number.unset_bit( number , i1b-- )
						}
					}
				}
				return number;
			},
			get_bits( number = 0 , i1position = 1 , length = 1 )
			{
				if( Number.isSafeInteger(number) === false ) { return number; }
				if( number > (1<<30) )                       { return number; }
				if( number <       0 )                       { return number; }
				if( (i1position + length) > 31 )             { return number; }
				if( i1position <  1 )                        { return number; }
				if( i1position > 30 )                        { return number; }
				if( length     <  1 )                        { return      0; }
				if( length     > 30 )                        { return number; }

				number >>= (i1position - 1)
				if( number === 0 ) { return 0; }

				const mask = 0xFFFFFFFF >> (32 - length)
				number &= mask;

				return number;
			},
			/**
			 * @param {number} float
			 * @param {number} bits
			 * @returns {string}
			 * */
			decimal_0_to_1_to_hex( float , bits )
			{
				const min_bits =  1
				const max_bits = 32
				const multiplicator = 4294967295 /* = 0xFFFFFFFF = 2^32 - 1 */

				check_and_handle_parameters()

				if( bits === 1 )
				{
					return (float < 0.5) ? "0" : "F";
				}
				if( bits === 2 )
				{
					float = Math.trunc( float * 4 )
					float = (float << 2) + float
					return float.toString(16);
				}

				float = float * multiplicator

				const rest = 4 - (bits % 4)
				if( rest < 4 )
				{
					bits += rest
				}

				const max_chars = max_bits / 4
				var hex = float.toString(16)
				if( hex.length < max_chars )
				{
					hex = "0".repeat( max_chars - hex.length ) + hex
				}

				const chars = bits >> 2

				if( hex.length > chars )
				{
					return hex.substring( 0 , chars );
				}
				if( hex.length === chars )
				{
					return hex;
				}
				if( hex.length < chars )
				{
					const prefix = "0".repeat( chars - hex.length )
					return prefix + hex;
				}

				function check_and_handle_parameters()
				{
					if( isNaN(float) ) { float = 0.0 }
					if( float >= 1.0 ) { float = 1.0 }
					if( float <  0.0 ) { float = 0.0 }
					
					bits = Math.trunc(bits)
					if( bits < min_bits ) { bits = min_bits }
					if( bits > max_bits ) { bits = max_bits }
				}
			}
		}
		,objects:
		{
			copy_values( source , destination )
			{
				Object.assign( destination , source )

				// const keys = Object.keys( source )
				// for( var i = 0;  i < keys.length;  i++ )
				// {
				// 	const key = keys[i];
				// 	const value = source[key]
				// 	if( typeof(value) === "string"
				// 		|| typeof(value) === "number"
				// 		|| typeof(value) === "boolean" )
				// 	{

				// 	}
				// 	if( Array.isArray( value ) )
				// 	{
				// 		value = Array.
				// 	}
				// }
			}
		}
		,strings:
		{
			/**
			 * @param { string | string[] } input
			 * @param { object } options
			 * @returns { string[] }
			 */
			to_string_array( input , options = {} )
			{
				const result = []
				// const delimiter = ",|;|\\s\\s\\s|\\|"

				if( typeof(options) != "object" )
				{
					options = {}
				}

				function get_delimiter()
				{
					return /,|;|\||\s\s\s/ ;
				}
				const delimiter = get_delimiter()

				if( typeof(input) === "string" )
				{
					input = input.split( delimiter )
				}

				if( Array.isArray( input ) )
				{
					for( var i = 0;  i < input.length ;  i++ )
					{
						if( typeof(input[i]) === "string" )
						{
							const s = input[i].trim()
							if( s.length > 0 )
							{
								result.push( s )
							}
						}
					}
				}

				return result;
			},
			digits_to_positivie_integer( digits_string ) {
				var result = 0
				var position = 0
				if( typeof(digits_string) === "string" )
				{
					while( position < digits_string.length )
					{
						const char = digits_string.charAt(position)
						const digit = tools.characters.to_digit(char)
						if( digit >= 0 )
						{
							result = result * 10 + digit
						}
						else
						{
							return -1 - position;
						}
						position += 1;
					}
				}
				return result;
			}
		}
		,characters:
		{
			/**
			 * @param {string} c 
			 * @returns {number}
			 */
			to_digit( c ) {
				if( (typeof( c ) === "string")
					&& (c.length === 1) )
				{
					const code_0 = "0".charCodeAt(0)
					const code = c.charCodeAt(0) - code_0
					if( code >= 0 )
						if( code <= 9 )
							return code;
				}
				return Number.NEGATIVE_INFINITY;
			}
		}
		,arrays:
		{
			/**
			 * @param {any[]} array 
			 * @param {any} element
			 * @param {object?} options
			 * @returns {number} how many elements were removed 
			*/
			remove_element( array , element , options = null )
			{
				var how_often = -1
				const start_index = 0

				var count = 0

				if( Array.isArray(array) )
				{
					if( how_often === -1 )	{ how_often = array.length	}

					var index = array.indexOf( element , start_index )
					while( index >= 0  &&  how_often > 0 )
					{
						array.splice( index , 1 )
						count = count + 1
						how_often = how_often - 1
						index = array.indexOf( element )
					}
				}

				return count;
			}
		}
		,debug:
		{
			objects:
			{
				object_JSON_to_console_debug( obj , space = 2 )
				{
					console.debug( JSON.stringify( obj , null , space ) )
				}
				,copy_to_console_debug( obj )
				{
					console.debug( 
						JSON.parse(
							JSON.stringify( obj , null , 2 ) 
						)
					)
				}
			}
		}
	}

	for( const key in tools )
	{
		if( key === "tools" ) { continue; }

		const category = tools[key]

		category.___parent = tools
		category.___root   = tools
	}

	return tools;
}
const tools = tools_tfxpnwhebwvtppxfcqnvtfazbndvhhnf()
//console.debug( tools );
const tools_tb2b4ca6f01544d2f9a67c8434c41114 = tools


const tools_to_string_array = tools.strings.to_string_array;
const tools_array_remove_element = tools.arrays.remove_element;

/** @param array {Array} */
function tools_array_remove( array , parameters , length = 1 )
{
	var index_set = false
	var index = 0
	var insert = []
	var replace = []

	if( Array.isArray(array) && typeof(parameters)==="object")
	{
		if( parameters.insert  &&  Array.isArray(parameters.insert)  &&  parameters.insert.length > 0 )
		{
			insert = parameters.insert
		}

		if( parameters.length > 0 )
		{
			length = 0 + parameters.length
		}

		if( parameters.index >= 0 )
		{
			index = 0 + parameters.index
			index_set = true
		}

		if( parameters.element )
		{
			const found = array.indexOf( parameters.element )
			if( found >= 0 )
			{
				index = found
				index_set = true
			}
		}

		if( index_set === true )
		{
			array.splice( index , length )
		}

		if( insert.length > 0 )
		{
			if( index_set === true )
			{
				tools_array_insert( array , index , insert )
			}
			else
			{
				tools_array_insert( array , array.length , insert )
			}
		}
	}
}

function tools_array_value( array , index0 , default_value = null , options = null )
{
	if( Array.isArray(array) )
	{
		if( index0 >= 0 && index0 < array.length )
		{
			return array[index0];
		}
		// else
		// if( index0 < 0 )
		// {
		// 	index0 += array.length
		// 	if( index0 >= 0 )
		// 	{
		// 		return array[index0];
		// 	}
		// }
	}
	return default_value;
}

function tools_array_insert( array , index, ...items )
{
	array.splice( index , 0 , ...items );
}

function tools_array_push_if_not_included( array , item )
{
	if( Array.isArray( array ) )
	{
		const found = array.indexOf( item )
		if( found < 0 )
		{
			array.push( item )
			return true;
		}
	}
	return false;
}

function tools_convert_value( value , unit , new_unit )
{
	if( typeof(value) === "string" )
	{
		value = tools_number_parse_localized( value )
	}

	if( typeof(value) === "number" )
	{
		switch( unit )
		{
			case "mm" :
			case "cm" :
			case "m"  :
			case "in" :
			case "f"  :
				return convert_length_mm();

			default: return null;
		}

		return value;
	}
	else
	{
		return null;
	}

	function convert_length_mm()
	{
		switch( unit )
		{
			case "mm" : value *=   0.1  ; unit = "cm" ; break;
			case "m"  : value *= 100.0  ; unit = "cm" ; break;
			case "in" : value *=   2.54 ; unit = "cm" ; break;
			case "f"  : value *=  30.48 ; unit = "cm" ; break;
		}

		if( unit === "cm" )
		{
			switch( new_unit )
			{
				case "cm" : break;
				case "mm" : value /=    0.1  ; break;
				case "m"  : value /=  100.0  ; break;
				case "in" : value /=    2.54 ; break;
				case "f"  : value /=   30.48 ; break;
				default: return null;
			}
			return value;
		}
	}
}


function tools_default_value( value , default_value )
{
	if( value == undefined )
	{
		return default_value;
	}
	if( typeof(value) == "undefined" )
	{
		return default_value;
	}
	return value;
}

/**
 * @param {number?}  x
 * @param {number}   default_value
 * @param {object}   options
 * @param {?number[]} options.values
 * @param {?number}   options.min
 * @param {?number}   options.max
 * @param {?boolean}  options.integer
 * @param {?number}   options.round
 * @param {?number}   options.round_up
 * @param {?number}   options.round_down
 * @param {?number}   options.round_towards_0
 * @param {?number}   options.truncate
 * @returns {number}
 * */
function tools_number_value( x , default_value = 0.0 , options = {} )
{
	var number = default_value;
	if( typeof(x) === "number"  ||  typeof(x) === "bigint" )
	{
		number = x;
		if( isNaN(x) )
		{
			number = default_value;
		}
	}
	else
	if( typeof(x) == "string" )
	{
		var number = Number.parseFloat(x)
		if( isNaN( number ) )
		{
			var number = Number.parseInt(x)
		}
		if( isNaN( number ) )
		{
			var number = default_value
		}
	}
	else
	{
		if( x == undefined )
		{
			return default_value;
		}
		if( typeof(x) == "undefined" )
		{
			return default_value;
		}
	}

	if( options != null )
	{
		if( Array.isArray(options.values) )
		{
			if( options.values.indexOf(number) < 0 )
			{
				var number = default_value
			}
		}
		if( options.min && number < options.min ) { var number = options.min }
		if( options.max && number > options.max ) { var number = options.max }
	}

	return number;
}

const tools_format_number_localized_nf = Intl.NumberFormat( undefined , { maximumFractionDigits: 3 })
function tools_number_format_localized( value , decimals = 3 )
{
	var nf = tools_format_number_localized_nf
	// if( typeof(decimals)==="number"  &&  decimals != 3  && decimals > 0 )
	// {

	// }

	return nf.format(value)
}

class tools_number_NumberParser {
	constructor( locale = undefined ) {
			const format = new Intl.NumberFormat(locale);
			const parts = format.formatToParts(-12345.6);
			const numerals = Array.from({ length: 10 }).map((_, i) => format.format(i));
			const index = new Map(numerals.map((d, i) => [d, i]));
			this._minusSign = new RegExp(`[${parts.find(d => d.type === 'minusSign').value}]`);
			this._group = new RegExp(`[${parts.find(d => d.type === 'group').value}]`, 'g');
			this._decimal = new RegExp(`[${parts.find(d => d.type === 'decimal').value}]`);
			this._numeral = new RegExp(`[${numerals.join('')}]`, 'g');
			this._index = d => index.get(d);
	}
	parse(string) {
			const DIRECTION_MARK = /\u061c|\u200e/g
			return +(
					string.trim()
					.replace(DIRECTION_MARK, '')
					.replace(this._group, '')
					.replace(this._decimal, '.')
					.replace(this._numeral, this._index)
					.replace(this._minusSign, '-')
			)
	}
}
const _tools_number_parse_localized_parser = new tools_number_NumberParser()
function tools_number_parse_localized( string )
{
	const p = _tools_number_parse_localized_parser
	return p.parse( string )
}


function tools_object_length( obj = null )
{
	if( !obj ) return 0
	if( typeof(obj) === "object" )	return Object.keys(obj).length;
	return 0
}

function tools_object_has_value( obj , value )
{
	if( Object.values )
	{
		return Object.values( obj ).includes( value );
	}
	else
	{
		develop.todo(" alternative if Object.values() is not supported")
		return 0;
	}
}

function tools_object_has_keys( obj , keys )
{
	if( typeof(obj) != "object" ) { return false }
	if( obj == null ) { return false }

	if( typeof(keys)==="string" )
	{
		keys = tools_to_string_array( keys )
	}
	if( Array.isArray(keys) )
	{
		for( const key of keys )
		{
			if( typeof(key)==="string" )
			{
				if( key in obj ) continue;
			}
			return false
		}
	}
	else
	{
		if( typeof(keys)==="object" )
		{
			for( const key in keys )
			{
				if( key in obj ) { continue; }

				return false;
			}
		}
		else
		{
			return false;
		}
	}

	return true;
}


function tools_assign_if_undefined( object , key, value )
{
	if( Object.hasOwn( object , key ) )
	{
		if( object[ key ] == undefined )
		object[key] = value
	}
	else
	{
		object[key] = value
	}
}


function tools_url_parameter( parameter , missing_result = "" , empty_result = " " )
{
	const page_url = window.location.search.substring(1)
	const url_variables = page_url.split('&')

	for( var i = 0;  i < url_variables.length;  i++)
	{
		const parameter_name = url_variables[i].split('=');

		if( parameter_name[0] === parameter )
		{
			return parameter_name[1] === undefined ? empty_result : decodeURIComponent(parameter_name[1]);
		}
	}
	return missing_result;
}

/** @param {!string} str */
/** @return {number} */
function tools_extract_number_from_string( str )
{
	if( typeof(str)==="string" )
	{
		str = str.trim().toLocaleLowerCase();
	}
	else
	{
		return -1;
	}

	if( typeof(str)==="string" )
	{
		var number_string = ""
		var seperator_space = 0
		var seperator_comma = 0
		var seperator_dot = 0
		var last_seperator = ""
		var last_seperator_position1 = 0
		var count_seperator = 0

		loop_chars:
		for( var i0C = 0 ;  i0C < str.length ;  i0C ++ )
		{
			const c = str.charAt(i0C)

			switch(c)
			{
				case '0':
				case '1':
				case '2':
				case '3':
				case '4':
				case '5':
				case '6':
				case '7':
				case '8':
				case '9':
				{
					number_string += c;
				} break;
				case ' ':
				case '.':
				case ',':
				{
					if( number_string.length > 0 )
					{
						number_string += c;
						last_seperator_position1 = number_string.length
						count_seperator += 1
					}
					break;
				}
				default:
				{
					if( number_string.length > 0 )
					{
						break loop_chars;
					}
				}
			}
		}

		if( (count_seperator > 0 )
			&& (last_seperator_position1 == number_string.length) )
		{
			str = number_string.substring( 0 , number_string.length - 1)
			count_seperator -= 1;
		}
		else
		{
			str = number_string
		}

		if( count_seperator <= 0 )
		{
			return tools_parse_positive_integer( number_string , -1 );
		}

		number_string = ""
		last_seperator_position1 = 0;

		for( var i0C = 0 ;  i0C < str.length ;  i0C ++ )
		{
			const c = str.charAt(i0C)

			switch(c)
			{
				case ' ':
					if( number_string.length > 0 )
					{
						seperator_space += 1
						last_seperator = " " ;
						last_seperator_position1 = number_string.length
					}
					break;
				case '.':
					if( number_string.length > 0 )
					{
						seperator_dot   += 1
						last_seperator = "." ;
						last_seperator_position1 = number_string.length
					}
					break;
				case ',':
					if( number_string.length > 0 )
					{
						seperator_comma += 1
						last_seperator = "," ;
						last_seperator_position1 = number_string.length
					}
					break;
				default:
				{
					number_string += c;
				}
			}
		}

		if( number_string.length ===  0 ) { return -1; }
		if( number_string.length  >  10 ) { return -1; }

		const different_seperators =
			( seperator_space & 1 ) +
			( seperator_comma & 1 ) +
			( seperator_dot   & 1 )

		if( different_seperators <= 0 )
		{
			return tools_parse_positive_integer( number_string , -1 );
		}
		else
		{
			if( different_seperators > 1 )
			{
				return tools_parse_positive_float( number_string , last_seperator_position1 , -1 );
			}
			else
			// if( different_seperators === 1 )
			{
				if ( count_seperator > 1 )
				{
					return tools_parse_positive_integer( number_string , -1 );
				}
				else
				{
					return tools_parse_positive_float( number_string , last_seperator_position1 , -1 )
				}
			}
		}
	}

	return -1;

	function tools_parse_positive_float( s , position1 = 0 , error_value = -1 )
	{
			if( position1 > 0 )
			{
					s = s.substring( 0 , position1 )
							+ "." +
							s.substring( position1 )
			}

			const parsed = Number.parseFloat( s )
			if( isNaN(parsed) ) { return error_value; }
			return parsed;
	}

	function tools_parse_positive_integer( s , error_value = -1 )
	{
			const parsed = Number.parseInt( s )
			if( isNaN(parsed) ) { return error_value; }
			return parsed;
	}
}


function tools_parse_positive_decimal( str , decimal_separator = 'auto' ) 
{
	if (typeof str !== 'string') 
	{
		str = String(str);
	}
	
	str = str.trim();
	
	// Auto-detect: last comma or dot is the decimal separator
	if( decimal_separator === 'auto' ) 
	{
		const lastComma = str.lastIndexOf(',');
		const lastDot = str.lastIndexOf('.');
		
		if( lastComma > lastDot ) 
		{
			// Comma is decimal separator (e.g., "1.234,56")
			str = str.replace(/\./g, '').replace(',', '.');
		} 
		else 
		{
			// Dot is decimal separator (e.g., "1,234.56")
			str = str.replace(/,/g, '');
		}
	}
	
	const num = parseFloat(str);
	return (num >= 0 && isFinite(num)) ? num : NaN;
}



/** 
 * @returns {HTMLElement?} 
 * @param {HTMLElement?     }  parent 
 * @param {string | any     } [tag=""      ] 
 * @param {string[] | string} [classes=[]  ] 
 * @param {string | any     } [id=""       ] 
 * @param {string | any     } [innerHTML=""] 
 * */
function html_create_element( parent, tag = "", classes = [], id = "" , innerHTML = "" )
{
	if( (tag === 0)||(tag === "")||(tag === null) )
	{
		tag = "div"
	}
	const e = document.createElement(tag)

	if(typeof(id) === "string" && id.length > 0)
	{
		e.id = id
	}

	if(Array.isArray(classes))
	{
		classes = classes.join(" ")
	}
	if( typeof(classes) === "string" )
	{
		classes = classes.trim()
		if( classes.length > 0 )
		{
			e.className = classes
		}
	}

	if(typeof(innerHTML) === "string" && innerHTML.length > 0)
	{
		e.innerHTML = innerHTML
	}

	if((parent != null) && (parent.appendChild))
	{
		parent.appendChild(e)
	}

	return e;
}

/** 
 * @param {HTMLElement?} reference_node
 * @param {HTMLElement?} new_node
 * @returns {boolean} 
 * */
function html_insert_after( reference_node, new_node )
{
	if( new_node instanceof HTMLElement
		&& reference_node instanceof HTMLElement
		&& (reference_node.parentNode)
		&& (reference_node.parentNode.insertBefore)	)
	{
		if( reference_node.nextSibling != null )
		{
			reference_node.parentNode.insertBefore( new_node, reference_node.nextSibling )
			return true
		}
		if( reference_node.nextSibling == null )
		{
			reference_node.parentNode.appendChild( new_node )
			return true
		}
	}
	return false
}

/**
 * @param { HTMLElement } element
 * @param { string! } selector
 * @returns { number }
 */
function html_remove_children( element , selector )
{
	if( typeof(selector) != "string" || selector.length < 1 ) return -2;

	try 
	{
		var children = element.querySelectorAll( selector )
		var count = children.length
	} 
	catch(error) { return -4; }

	for( var i = 0;  i < children.length;  i++ )
	{
		try 
		{
			const child = children[i]
			if( element.contains(child) === true )
			{
				element.removeChild( child )
			}
		} 
		catch(error) {continue;}
	}

	return count;
}


function tools_copy_values( source , destination )
{
	Object.assign( destination , source )
}


function tools_NOT( booleans )
{
	if( Array.isArray( booleans ) )
	{
		return tools_NOT( ...booleans )	
	}

	for( const b of arguments )
	{
		if( Array.isArray(b) )
		{
			if( false === tools_NOT( ...b ) )
			{
				return false;
			}
		}
		else
		if( "boolean" === typeof(b)
			&& true == b )
		{
			return false;
		}
		else
		if( b == true ) 
		{
			return false; 
		}
	}

	return true;
}

function tools_ALL( booleans )
{
	if( Array.isArray( booleans ) )
	{
		return tools_ALL( ...booleans )	
	}

	for( const b of arguments )
	{
		if( Array.isArray(b) )
		{
			if( false === tools_ALL( ...b ) )
			{
				return false;
			}
		}
		else
		if( "boolean" === typeof(b)
			&& false == b )
		{
			return false;
		}
		else
		if( b == false ) 
		{
			return false; 
		}
	}

	return true;
}

function tools_ANY( booleans )
{
	if( Array.isArray( booleans ) )
	{
		return tools_ANY( ...booleans )	
	}

	for( const b of arguments )
	{
		if( Array.isArray(b) )
		{
			if( true === tools_ANY( ...b ) )
			{
				return true;
			}
		}
		else
		if( "boolean" === typeof(b)
			&& true == b )
		{
			return true;
		}
		else
		if( b == true ) 
		{
			return true; 
		}
	}

	return false;
}

function tools_NOT_ANY( booleans )
{
	return !tools_ANY( booleans );
}

function tools_NONE( booleans )
{
	return !tools_ANY( booleans );
}
